// @ts-strict-ignore
import { CellRange } from '../handsontable-3rdparty/range.js';

export class MergeAndDivideAction {

  private cellRange: CellRange;
  private isMerge: boolean;
  private oldCellDataList;
  private restoreCellCoordsStringToOldColSpanMap: Map<string, number>;

  constructor(cellRange: CellRange, isMerge: boolean, oldCellDataList,
    restoreCellCoordsStringToOldColSpanMap: Map<string, number>) {
    this.cellRange = cellRange;
    this.isMerge = isMerge;
    this.oldCellDataList = oldCellDataList;
    this.restoreCellCoordsStringToOldColSpanMap = restoreCellCoordsStringToOldColSpanMap;
  }

  public undo(instance, undoneCallback) {
    // instance is of type handsontable, which gets applied by handsontable to done actions (action part of undostack)
    instance.labelEditorTabComponent.mergeAndDivideCells(this.cellRange, !this.isMerge, this.restoreCellCoordsStringToOldColSpanMap);
    instance.setDataAtCell(this.oldCellDataList);
    // undo operation completed, trigger callback:
    // this is original callback style, now improved by doing callback immediately
    // instance.addHookOnce('afterRender', undoneCallback);
    // instance.render();
    if (undoneCallback) {
      undoneCallback();
    }
  }

  public redo(instance, redoneCallback) {
    instance.labelEditorTabComponent.mergeAndDivideCells(this.cellRange, this.isMerge);
    // redo operation completed, trigger callback:
    // this is original callback style, now improved by doing callback immediately
    // instance.addHookOnce('afterRender', redoneCallback);
    // instance.render();
    if (redoneCallback) {
      redoneCallback();
    }
  }
}
